import styled from 'styled-components';
import { breakpoints } from '@sorted/sorted-ui';
import colors from '../../colors';

const ListWrapper = styled.div`
	margin: 0;
	padding: 0;
	background-color: ${colors.dgray};
	width: 100%;
	position: relative;

	@media (min-width:${breakpoints.smallDesktop}) {
		${props =>
			!!props.subMenu && {
				position: 'absolute',
				left: '100%',
				width: 'auto',
				'min-width': '230px'
			}}
		top: ${({ direction }) => (direction === 'up' ? 'auto' : 0)};
		bottom: ${({ direction }) => (direction === 'up' ? 0 : 'auto')};
		margin-top: ${({ direction }) => (direction === 'up' ? 'auto' : 0)};
	}
`;

export default ListWrapper;
